import type { CredifyConfig, Mode } from "../types";

export const hosts = (config: CredifyConfig) => {
  switch (config.mode) {
    case "production":
      return {
        api: "https://api.credify.one/",
        oidcCore: "https://oidc-core.credify.one/",
        oidcAuth: "https://oidc-auth.credify.one/",
      };
    case "sandbox":
      return {
        api: "https://sandbox-api.credify.dev/",
        oidcCore: "https://sandbox-oidc-core.credify.dev/",
        oidcAuth: "https://sandbox-oidc-auth.credify.dev/",
      };
    case "tis-sandbox":
      return {
        api: "https://shirahama.credify.dev/",
        oidcCore: "https://tis-sandbox-oidc-core.credify.dev/",
        oidcAuth: "https://tis-sandbox-oidc-auth.credify.dev/",
      };
    case "tis-production":
      return {
        api: "https://shirahama.credify.one/",
        oidcCore: "https://tis-oidc-core.credify.one/",
        oidcAuth: "https://tis-oidc-auth.credify.one/",
      };
    case "uat":
      return {
        api: "https://uat-api.credify.dev/",
        oidcCore: "https://uat-oidc-core.credify.dev/",
        oidcAuth: "https://uat-oidc-auth.credify.dev/",
      };
    case "sit":
      return {
        api: "https://sit-api.credify.ninja/",
        oidcCore: "https://sit-oidc-core.credify.ninja/",
        oidcAuth: "https://sit-oidc-auth.credify.ninja/",
      };
    case "development":
      return {
        api: "https://dev-api.credify.ninja/",
        oidcCore: "https://dev-oidc-core.credify.ninja/",
        oidcAuth: "https://dev-oidc-auth.credify.ninja/",
      };
    case "local":
      return {
        api: "http://localhost:8000/",
        oidcCore: "http://localhost:4444/",
        oidcAuth: "http://localhost:3000/",
      };
  }
};

export const apiBase = (mode: Mode) => {
  switch (mode) {
    case "production":
      return "https://api.credify.one";
    case "sandbox":
      return "https://sandbox-api.credify.dev";
    case "tis-sandbox":
      return "https://shirahama.credify.dev";
    case "tis-production":
      return "https://shirahama.credify.one";
    case "uat":
      return "https://uat-api.credify.dev";
    case "sit":
      return "https://sit-api.credify.ninja";
    case "development":
      return "https://dev-api.credify.ninja";
    case "local":
      return "http://localhost:8000";
  }
}

export const ecosystemId = (config: CredifyConfig) => {
  switch (config.mode) {
    case "production":
      return "74e95121-0cd3-4613-9bf5-b9fa65b7a9e1";
    case "sandbox":
      return "62fc5724-3751-4797-be79-605635fa6c93";
    case "uat":
      return "62fc5724-3751-4797-be79-605635fa6c93";
    case "sit":
      return "62fc5724-3751-4797-be79-605635fa6c93";
    case "development":
      return "62fc5724-3751-4797-be79-605635fa6c93";
    case "local":
      return "62fc5724-3751-4797-be79-605635fa6c93";
  }
};
